import { StringUtil } from "@mcleod/core";
import { RowPermsAllowDeny } from "../models/ModelPermsAllowDeny";
import { RowPermsSecureItem } from "../models/ModelPermsSecureItem";
import { UserOrGroup } from "./UserOrGroup";

export interface PermsSecureItemKeyData {
    item_name: string;
    screen_class: string;
    security_type: string;
}

export class PermissionsKeyGenerator {
     static createKey(data:PermsSecureItemKeyData | RowPermsSecureItem | RowPermsAllowDeny): string {
        if (data instanceof RowPermsSecureItem || data instanceof RowPermsAllowDeny) {
            data = data.data;
        }

        if (StringUtil.isEmptyString(data?.item_name) || StringUtil.isEmptyString(data?.screen_class) || StringUtil.isEmptyString(data?.security_type)) {
            throw new Error("Unable to determine screen class, item name, and security type");
        }

        return `${data.item_name}:${data.screen_class}:${data.security_type}`;
    }

    static createAllowDenyKey(data: {userOrGroup: UserOrGroup, id: string} | RowPermsAllowDeny): string {
        if (data instanceof RowPermsAllowDeny) {
            data = {
                userOrGroup: data.get("user_or_group_flag") as UserOrGroup,
                id: data.get("user_or_group_id")
            };
        }

        if (StringUtil.isEmptyString(data?.userOrGroup) || StringUtil.isEmptyString(data?.id)) {
            throw new Error("Unable to determine user or group and id");
        }

        return `${data.userOrGroup}:${data.id}`;
    }

    static isGroupKey(key: string): boolean {
        return key?.startsWith("G:") ?? false;
    }

    static isUserKey(key: string): boolean {
        return key?.startsWith("U:") ?? false;
    }

    static extractIdFromKey(key: string): string | null {
        const parts = key?.split(":") ?? [];
        return parts[1] ?? null;
    }
}
